var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-credit"},[_c('transition',{attrs:{"name":"sticky-credit__fade"}},[_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"sticky-credit__badge",attrs:{"pill":"","variant":"primary"}},[_c('availability')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }